<template>
  <v-dialog v-bind="attrs" v-model="modelValue" scroll-strategy="none" :width="width">
    <template #activator="slotData">
      <slot name="activator" v-bind="slotData" />
    </template>
    <slot />
  </v-dialog>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'

defineProps({
  width: {
    type: Number,
    default: 500
  }
})

const modelValue = defineModel({
  type: Boolean,
  required: true
})

const attrs = useAttrs()
</script>
